import route from 'ziggy';
import {Ziggy} from "../routes";

export function ziggy_route(name, params = {}, absolute = false, config = Ziggy) {
    return route(name, params, absolute, config);
}
